import Verify from './src/main'
import { addComponent } from '~/utils/helper'

export default addComponent(Verify)


// WEBPACK FOOTER //
// ./public/verify/index.js